
import XHeader from 'vux/src/components/x-header/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import { go } from '../../libs/router'
import store from '../../vuex/store'
export default {
components: {
XHeader,
XButton,
XDialog,
Alert,
Loading,
Confirm,
Toast
},
data () {
return {
hideOnBlur: true,
pullHeight: window.innerHeight,
disabled: true,
isShow: false,
fpList: [],
warnMsgShow: false,
warnMsg: '',
showImg: '',
isNoCard: false,
loadingShow: false,
loadingText: '加载中',
startPos: 0,
endPos: 0,
currentX: 0,
index: -1,
isMoved: false,
confirmStatus: false,
delId: '',
delIndex: -1,
toastShow: false,
toastMsg: '',
delTime: 0
}
},
created () {
var _this = this
_this.loadingShow = true
_this.query()
},
mounted () {
store.commit( 'UPDATE_TITLE', '发票名片' )
store.commit( 'UPDATE_SHOW_FOOTER', true )
},
methods: {
query () {
var _this = this
_this.$ajax.post( _this.ajaxFactory.get( 'businessCardList' ), {} ).then( function ( response ) {
var result = response.data
_this.loadingShow = false
if ( result.total ) {
_this.fpList = result.list
} else if ( result.code === '500' ) {
_this.warnMsgShow = true
_this.warnMsg = result.msg
_this.isNoCard = true
} else {
_this.isNoCard = true
}
} )
.catch( function ( response ) {
_this.loadingShow = false
_this.isNoCard = true
console.log( response )
} )
},
onClick ( link ) {
go( link, this.$router )
},
share ( img ) {
console.log( '--------' )
this.isShow = true
this.showImg = img
},
hideQrcode () {
for ( var i = 0; i < this.isShow.length; i++ ) {
this.isShow[i] = false
}
},
touchStart ( e ) {
this.startPos = e.touches[0].pageX
},
touchMove ( e ) {
this.endPos = e.touches[0].pageX
this.isMoved = true
},
touchEnd ( id, e ) {
if ( this.startPos > ( -this.endPos ) && ( this.startPos - this.endPos ) > 75 && this.isMoved ) {
if ( this.index !== -1 ) {
document.getElementById( this.index ).setAttribute( 'class', 'item' )
}
this.index = id
document.getElementById( id ).setAttribute( 'class', 'item selected' )
} else if ( this.endPos > this.startPos && ( this.endPos - this.startPos ) > 75 && this.isMoved && this.index === id ) {
if ( this.index !== -1 ) {
document.getElementById( id ).setAttribute( 'class', 'item' )
}
this.index = -1
} else if ( e.target.className !== 'remove' && !this.isMoved && e.target.tagName !== 'IMG' ) {
this.onClick( '/viewCard/' + id )
}
this.isMoved = false
},
onCancel () {
console.log( 'on cancel' )
},
onHide () {
console.log( 'on hide' )
},
onShow () {
console.log( 'on show' )
},
onConfirm () {
var _this = this
var timestamp = Date.parse( new Date() )
if ( timestamp - _this.delTime > 200 ) {
_this.$ajax.post( _this.ajaxFactory.get( 'deleteBusinessCard' ), {}, {
params: { id: _this.delId }
} ).then( function ( response ) {
var result = response.data
if ( result.code === '200' ) {
_this.toastMsg = '删除成功'
_this.toastShow = true
document.getElementById( _this.delId ).setAttribute( 'class', 'item' )
_this.fpList.splice( _this.delIndex, 1 )
_this.delIndex = -1
_this.index = -1
} else {
_this.warnMsg = result.msg
_this.warnMsgShow = true
}
} )
.catch( function ( response ) {
console.log( response )
} )
}
},
deleteItem ( index, id ) {
var _this = this
var timestamp = Date.parse( new Date() )
_this.delTime = timestamp
_this.confirmStatus = true
_this.delId = id
_this.delIndex = index
}
}
}



// WEBPACK FOOTER //
// ./src/components/card/invoiceCard.vue